const memoria = new Map<string, Record<string, string>>();

const namespace = (usuarioId: string, processoId: string) =>
  `arbitro:respostas:${usuarioId}:${processoId}`;

export function lerChavesResposta(usuarioId: string, processoId: string): Record<string, string> {
  const chave = namespace(usuarioId, processoId);
  const existente = memoria.get(chave);
  if (existente) return existente;
  let chaves: Record<string, string> = {};
  try {
    const salvo: unknown = JSON.parse(sessionStorage.getItem(chave) ?? '{}');
    if (salvo && typeof salvo === 'object' && !Array.isArray(salvo)) {
      chaves = Object.fromEntries(
        Object.entries(salvo).filter(
          (entry): entry is [string, string] => typeof entry[1] === 'string',
        ),
      );
    }
  } catch {
    /* O modo privado pode recusar storage; a mesma visita ainda conserva a chave. */
  }
  memoria.set(chave, chaves);
  return chaves;
}

function persistir(usuarioId: string, processoId: string, chaves: Record<string, string>): void {
  try {
    sessionStorage.setItem(namespace(usuarioId, processoId), JSON.stringify(chaves));
  } catch {
    /* Mantém o fallback da visita. */
  }
}

export function chaveDaResposta(
  usuarioId: string,
  processoId: string,
  pendenciaId: string,
): string {
  const chaves = lerChavesResposta(usuarioId, processoId);
  chaves[pendenciaId] ??= crypto.randomUUID();
  persistir(usuarioId, processoId, chaves);
  return chaves[pendenciaId];
}

export function liberarChaveResposta(
  usuarioId: string,
  processoId: string,
  pendenciaId: string,
  clientRequestId: string,
): void {
  const chaves = lerChavesResposta(usuarioId, processoId);
  if (chaves[pendenciaId] !== clientRequestId) return;
  delete chaves[pendenciaId];
  persistir(usuarioId, processoId, chaves);
}
